<ion-app>
    <ion-split-pane (ionSplitPaneVisible)="splitPaneVisible(commonFunctions.asCustomEvent($event).detail.visible)"
                    [disabled]="appState.splitPaneHidden" contentId="main">
        <ion-menu id="menu" menuId="authenticated" side="start" contentId="main">
            <ion-header>
                <ion-toolbar>
                    <ion-title>{{'menu.title' | translate}}</ion-title>
                </ion-toolbar>
            </ion-header>
            <ion-content>
                <ion-list
                    [attr.data-intro]="(!activePage || (activePage.name !== 'home')) ? null : 'help.menu'|translate">
                    <ion-item>{{'login_info' | translate}}&nbsp;<span class="no-wrap">{{userName}}</span></ion-item>
                    <ion-menu-toggle auto-hide="false" *ngFor="let page of appPages">
                        <ion-item *ngIf="!page.hidden || (page.hidden && activePage && (activePage.name === page.name))"
                                  detail="false" routerLinkActive="active"
                                  button color="light" lines="full"
                                  routerDirection="root" [routerLink]="[page.url]"
                                  [attr.data-intro]="(!activePage || (activePage.name !== 'home')) ? null : 'help.page-'
                                   + page.name|translate"
                        >
                            <!-- *ngIf="!activePage || (activePage.name != page.name)" -->
                            <ion-icon slot="start"
                                      [name]="page.icon"></ion-icon>
                            <ion-label>
                                {{ 'menu.' + page.name | translate}}
                            </ion-label>
                        </ion-item>
                        <div [class.menuOption]="activePage && (activePage.name === page.name)">
                            <ng-container appIdViewRef [id]="'menuOption' + page.name"></ng-container>
                        </div>
                    </ion-menu-toggle>
                    <ion-button class="right" (click)="showHelp()" size="small" fill="outline">
                        {{'menu.help' | translate}}</ion-button>
                </ion-list>
            </ion-content>
        </ion-menu>
        <ion-router-outlet id="main"></ion-router-outlet>
    </ion-split-pane>
</ion-app>
